import React from "react";
import { Box, Flex, Text } from "@radix-ui/themes";
import styles from "./styles.module.scss";

const Footer = ({ showLogo = true, menuItems = [], logo }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box className={styles.footer}>
      <Flex
        direction="column"
        align="center"
        gap="4"
        className={styles.content}
      >
        {showLogo && logo && (
          <img src={logo} alt="Logo" className={styles.logo} />
        )}

        {menuItems.length > 0 && (
          <Flex gap="5" wrap="wrap" justify="center" className={styles.menu}>
            {menuItems.map((item, index) => (
              <a key={index} href={item.href} className={styles.menuLink}>
                {item.label}
              </a>
            ))}
          </Flex>
        )}

        <Text className={styles.copyright}>
          © {currentYear} Renova Aesthetic Clinic. All rights reserved.
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
